/**
 * Created by sindre on 27.10.2015.
 */

var VRC = VRC || {};

VRC.Utils = VRC.Utils || {};

VRC.Utils.Forms = (function(){
  /**
   * Serializes to object instead of an array
   * @param $object form element or inputelements.
   */
  var serializeObject = function ($object) {
    var o = {};
    var a = $object.serializeArray();

    // Set all unchecked input boxes properties to "off" so they can be disabled. serializeArray omits unchecked boxes.
    $object.closest('input[type=checkbox]:not(:checked)').each(function(){
        if(this.name.indexOf('properties.') === 0) {
            a.push({name: this.name, value: 'off'});
        }
        if(this.name.indexOf('properties.dangerous') === 0) {
            a = _.filter(a, function(o) { return o.name !== 'dg_class' });
            a.push({name: 'dg_class', value: ''});
        }
    });
    $object.closest('select#edit-container__dgClass').each(function() {
      if($(this).val() === null && a[this.name] === undefined)
        a[this.name] = '';
    });

    var createProp = function(o, name, value){

      if(name.indexOf('.') > -1){
        var array =  name.split('.');
        var newName = array[0];
        var secondName = name.substr(newName.length + 1, name.length);


        o[newName] = o[newName] || {};
        o[newName] = createProp(o[newName], secondName, value)
      }
      else{
        if (o[name] !== undefined) {
          if (!o[name].push) {
            o[name] = [o[name]];
          }
          o[name].push(value || '');
        } else {
          o[name] = value || '';
        }
      }
      return o;
    };

    $.each(a, function () {
      var name = this.name;
      var value = this.value;
      o = createProp(o, name, value);

    });

    return o;
  };

  return {
    serializeObject : serializeObject
  }
})();

var VRC = VRC || {};

VRC.Utils = VRC.Utils || {};

VRC.Utils.String = (function(){

  var toPascalCase = function(underCased){
    var array = underCased.split('_');
    var str = '';
    for(var ii = 0; ii < array.length; ii++){
      str += array[ii].charAt(0).toUpperCase() + array[ii].slice(1);
    }
    return str;
  };

  var validateDgClasses = function(dgClass) {
      return dgClass.replace(/[,\s]+/g, ',').replace(/^[,]+|[,]+$/g, '');   // replace 1+ comma with ',' , remove 1+ comma at the beginning and the end of the string.
  };

  return {
    toPascalCase : toPascalCase,
    validateDgClasses : validateDgClasses
  }
})();


